import React from 'react'

import ServiceMenuTemplate from '../../../templates/ServiceMenuTemplate'

const Asoko2Menu = () => {
  const props = {
    pageTitle: 'asoko2',
    upperNavLinkTitle: 'opt_picking_list_full',
    upperNavTo: '/pickingmenu',
//  lowerNavLinkTitle: 'opt_scenario_verif',
    lowerNavLinkTitle: 'opt_picking_list_general',
    //lowerNavTo: '/simulationmenu',
    lowerNavTo: '/pickinggeneralmenu',
    backTo: '/home'
  }

  return <ServiceMenuTemplate props={props} />
}

export default Asoko2Menu
